import api from 'api/apiInstance';

export function advisersExportReportApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
